import { render, staticRenderFns } from "./modal-reach-customer-service.vue?vue&type=template&id=639a45b0"
import script from "./modal-reach-customer-service.vue?vue&type=script&lang=js"
export * from "./modal-reach-customer-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports